import React from "react";
import { useTranslation } from "react-i18next";
import { AdminFormFieldSubmit } from "../components/admin/formFields";

type TSortingStatusWithResetProps = {
  ordering?: string;
  columnOrderingFields: Record<string, string>;
  onResetOrdering: () => void;
  showOrder?:boolean;
};

const getOrderingColumnLabel = (
  ordering: string,
  columnOrderingFields: Record<string, string>
) => {
  const orderingValue = ordering.startsWith("-")
    ? ordering.substring(1)
    : ordering;

  return (
    Object.keys(columnOrderingFields).find(
      (label) => columnOrderingFields[label] === orderingValue
    ) || orderingValue
  );
};

export const SortingStatusWithReset = ({
  ordering,
  columnOrderingFields,
  onResetOrdering,
  showOrder=false
}: TSortingStatusWithResetProps) => {
  const { t: tAdmins } = useTranslation("translation", { keyPrefix: "admins" });

  if (!ordering) return null;

  const orderingLabel = getOrderingColumnLabel(ordering, columnOrderingFields);

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="text-sm text-heading-gray888 leading-6">
          {ordering.startsWith("-")
            ? `${tAdmins("sorted_by", { column: orderingLabel })} ${showOrder ? "(Descending)" : "(Z-A)"}`
            : `${tAdmins("sorted_by", { column: orderingLabel })} ${showOrder ? "(Ascending)" : "(A-Z)"}`}
        </div>
        <AdminFormFieldSubmit
          variant="text-like"
          type="button"
          label={tAdmins("reset_sorting")}
          onClick={onResetOrdering}
          buttonDimensionClass="h-8 w-full px-4"
        />
      </div>
    </>
  );
};
